import { FC } from "react";

type TruncatedTextProps = {
  text: string;
  maxLength?: number;
};

const TruncatedText: FC<TruncatedTextProps> = ({ text, maxLength = 17 }) => {
  const isTruncated = text.length > maxLength;
  const displayText = isTruncated ? text.slice(0, maxLength) + "..." : text;

  return (
    <div className="relative  inline-block cursor-pointer">
      <span className=" group">{displayText}
      {isTruncated && (
        <div className="absolute bottom-0  -right-10   px-3 py-2 text-sm text-white bg-black rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
          {text}
        </div>
      )}
      </span>
    </div>
  );
};

export default TruncatedText;